
import { TreeList, Validator } from "devextreme-react";
import { Column, Editing, IStateStoringProps, RequiredRule } from "devextreme-react/tree-list";
import * as React from "react";
import { IOperationeleDoelstelling } from "../../models/OperationeleDoelstelling";
import useDataSource from "../../components/hooks/DataSource";
import { useCallback, useMemo, useRef } from "react";
import DirtyPrompt from "../../components/DirtyPrompt";

interface IProps {
    apiUrl: string;
    stateStoreKey?: string;
    onSaaved?: () => void;
}

const OperationeleDoelstellingen = ({ apiUrl, stateStoreKey, onSaaved }: IProps) => {

    const ds = useDataSource(apiUrl);
    const tlRef = useRef<TreeList<IOperationeleDoelstelling, number>>(null);
    const isDirtyHandler = useCallback(() => tlRef.current?.instance.hasEditData(), [])
    const stateStoring = useMemo((): IStateStoringProps | undefined => (stateStoreKey && { storageKey: stateStoreKey, type: "localStorage", enabled: true }) || undefined, [stateStoreKey])

    return <>
        <DirtyPrompt when={isDirtyHandler} />
        <h2>Operationele doelstellingen</h2>
        <TreeList<IOperationeleDoelstelling, number>
            ref={tlRef}
            dataSource={ds}
            parentIdExpr="hoofdDoelstellingId"
            stateStoring={stateStoring}
            rootValue={undefined}
            noDataText={undefined}
            onSaved={onSaaved}   
        >
            <Column dataField="naam" >
                
                    <RequiredRule />                

            </Column>

            <Editing
                mode="batch"
                useIcons={true}
                //startEditAction="dblClick"
                //startEditAction="click"
                allowAdding={true}
            
                allowDeleting={true}
                allowUpdating={true} />

            {/*<RowDragging*/}
            {/*    onReorder={onReorder}*/}
            {/*    //onDragStart={(e: any) => e.cancel = !e.itemData.id}*/}
            {/*    allowDropInsideItem={true}*/}
            {/*    allowReordering={true} />*/}

    </TreeList>
    </>
}
export default OperationeleDoelstellingen;